/**
 * orga-app-api - incidents-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface IncidentAktualisierenRequest { 
    ist_veranstaltungsrelevant?: boolean;
    ist_verantwortlichkeit_abteilung?: boolean;
    ist_verantwortlichkeit_zentrale?: boolean;
    veranstaltung_id?: string;
    verantwortlichkeit_funktionsbereich_id?: string;
    incident_id: string;
}

